<template>
  <div class="PublicationProjectPage">
    <PublicationProject :token="token" :language="language" />
  </div>
</template>
<script>
window["multirapports"] = window["multirapports"] || {};
export default {
  name: "PublicationProjectPage",
  data: () => ({
    token: null,
    language: "",
  }),
  created() {
    this.token = sessionStorage.getItem("adal.idtoken");
  },
  mounted() {
    this.language = localStorage.getItem("UserLang")
      ? localStorage.getItem("UserLang")
      : this.$i18n.locale;
  },
  components: {
    ...window["multirapports"].default,
  },
};
</script>
<style lang="scss">
.PublicationProjectPage {
  top: 73px;
  position: relative;
  z-index: 99;
  left: 200px;
  width: calc(100% - 180px);
  padding-bottom: 63px;
  overflow-y: scroll;
  min-height: calc(100vh - 127px);
}
@media print {
  .PublicationProjectPage {
    left: 0px !important;
    overflow-y: hidden !important;
  }
}
@media (max-width: 480px) and (min-width: 320px) {
  .PublicationProjectPage {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 46px;
    width: calc(100% - 34px);
  }
}

@media (max-width: 640px) and (min-width: 480px) {
  .PublicationProjectPage {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 40px;
    width: calc(100% - 34px);
  }
}
@media (max-width: 768px) and (min-width: 640px) {
  .PublicationProjectPage {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 40px;
    width: calc(100% - 34px);
  }
}
</style>
